import * as classNames from "classnames";
import * as React from 'react';
import { Control, LocalForm } from "react-redux-form";
import { withTheme } from '../../common/withTheme';
import InternalClassificationLink from "../Framework/Common/Links/InternalClassificationLink";
import Loader from "react-loaders";

interface ILoginProps {
    className?: string;
    loggingIn: boolean;
    theme?: string;
    title: string;
}

interface ILoginActions {
    logout: any;
    login: any;
}

export interface ILoginState {
}

type LoginProps = ILoginProps & ILoginActions;

class Login extends React.PureComponent<LoginProps, ILoginState> {
    formDispatch;
    constructor(props, context) {
        super(props, context);

    }

    onLoginFormClick(login) {
        this.props.login(login.username, login.password, login.rememberMe);
    }

    render() {
        const loginForm = <LocalForm
            model="login"
            className={classNames(this.props.theme, this.props.className, "form login-form")}
            onSubmit={login => this.onLoginFormClick(login)}
            getDispatch={(dispatch) => this.formDispatch = dispatch}
            validateOn="submit">
            <div className="form-fields">
                <label className="lead my-0">Email</label>
                <Control.text
                    model=".username"
                    id="login.email"
                    className="form-control form-control-sm mb-2"
                    maxLength={100}
                    required={true}
                />
                <label className="lead my-0">Password</label>
                <Control.text
                    model=".password"
                    id="login.password"
                    type="password"
                    className="form-control form-control-sm mb-2"
                    maxLength={100}
                    required={true}
                />
                <div className="form-check">
                    <Control.checkbox
                        model=".rememberMe"
                        id="login.rememberMe"
                        className="form-check-input"
                    />
                    <label className="lead form-check-label">Remember me</label>
                </div>
                <button className={`${this.props.theme} btn btn-primary btn-lg mt-2 align-self-end`}>LOGIN</button>

                {/*textPasswordForgot ? InternalClassificationLink("user/passwordreset", textPasswordForgot, undefined, "mt-3 text-center") : undefined}
                {textActivationResent ? InternalClassificationLink("user/activateaccount", textActivationResent, undefined, "mt-3 text-center") : undefined*/}

            </div>
        </LocalForm >;

        return (
            this.props.loggingIn ? <div className="d-flex justify-content-center my-5"
                style={{ opacity: 0.75, zIndex: 80, bottom: '15px' }}>
                <Loader type="ball-scale-multiple" active />
                <div className="ml-4">logging in</div>
            </div> : loginForm
        );
    }
}

export default withTheme<LoginProps>(Login);
